export default "__VITE_ASSET__Z9GwVq2u__"